export default "__VITE_ASSET__BvW73lSw__"